import { RouteComponentProps, navigate } from "@reach/router"
import { Unauthorized as UnauthorizedUI } from "@shared/application-components"
import { useAuth } from "../../contexts"

export const Unauthorized: React.FC<RouteComponentProps> = () => {
  const { logout } = useAuth()
  const onLogoutClick = async () => {
    await logout()
    navigate(`/login`)
  }

  return (
    <UnauthorizedUI
      onLogoutClick={onLogoutClick}
      text="It looks like you aren't authorised to view this page. Please try logging out and switching user."
    />
  )
}
